import { MDSIcon } from '@marqvision/mds-v2';
type IcoProps = {
  className?: string;
  style?: React.CSSProperties;
  width?: string | number;
  height?: string | number;
  onClick?: (e: React.MouseEvent<SVGSVGElement>) => void;
  onMouseDown?: (e: React.MouseEvent<SVGSVGElement>) => void;
};

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoAddPlusOutline = (props: IcoProps) => <MDSIcon.AddPlus variant="outline" {...props} />; //AddPlusOutline;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoArrowDownOutline = (props: IcoProps) => <MDSIcon.ArrowDown variant="outline" {...props} />; //ArrowDownOutline;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoArrowLeftBorder = (props: IcoProps) => <MDSIcon.ArrowLeft variant="border" {...props} />; //ArrowLeftBorder;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoArrowLeftOutline = (props: IcoProps) => <MDSIcon.ArrowLeft variant="outline" {...props} />; //ArrowLeftOutline;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoArrowRightBorder = (props: IcoProps) => <MDSIcon.ArrowRight variant="border" {...props} />; //ArrowRightBorder;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoArrowRightOutline = (props: IcoProps) => <MDSIcon.ArrowRight variant="outline" {...props} />; //ArrowRightOutline;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoArrowUpOutline = (props: IcoProps) => <MDSIcon.ArrowUp variant="outline" {...props} />; //ArrowUpOutline;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoAttachfile = (props: IcoProps) => <MDSIcon.AttachFile {...props} />; //Attachfile;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoCheckFill = (props: IcoProps) => <MDSIcon.Check variant="fill" {...props} />; //CheckFill;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoCheckOutline = (props: IcoProps) => <MDSIcon.Check variant="outline" {...props} />; //CheckOutline;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoCheckedWhite = (props: IcoProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="24" height="24" fill="white" fillOpacity="0.01" />
    <path
      d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM10.71 16.29C10.32 16.68 9.69 16.68 9.3 16.29L5.71 12.7C5.32 12.31 5.32 11.68 5.71 11.29C6.1 10.9 6.73 10.9 7.12 11.29L10 14.17L16.88 7.29C17.27 6.9 17.9 6.9 18.29 7.29C18.68 7.68 18.68 8.31 18.29 8.7L10.71 16.29V16.29Z"
      fill="white"
    />
  </svg>
);

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoUncheckedWhite = (props: IcoProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="24" height="24" fill="white" fillOpacity="0.01" />
    <path
      d="M19 19L5 19V5H19V19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
      fill="white"
    />
  </svg>
);

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoCloseDeleteRemoveBorder = (props: IcoProps) => <MDSIcon.CloseDelete variant="border" {...props} />; //CloseDeleteRemoveBorder;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoCloseDeleteRemoveFill = (props: IcoProps) => <MDSIcon.CloseDelete variant="fill" {...props} />; //CloseDeleteRemoveFill;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoCloseDeleteRemoveOutline = (props: IcoProps) => <MDSIcon.CloseDelete variant="outline" {...props} />; //CloseDeleteRemoveOutline;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoCopyContent = (props: IcoProps) => <MDSIcon.CopyContent variant="outline" {...props} />; // CopyContent

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoDocument = (props: IcoProps) => <MDSIcon.Document variant="fill" {...props} />; //Document;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoDownload = (props: IcoProps) => <MDSIcon.Download {...props} />; //Download;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoEdit = (props: IcoProps) => <MDSIcon.Edit variant="fill" {...props} />; //Edit;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoErrorWarningFill = (props: IcoProps) => <MDSIcon.ErrorWarning variant="fill" {...props} />; //ErrorWarningFill;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoExcelSheet = (props: IcoProps) => <MDSIcon.ExcelSheet {...props} />; //ExcelSheet;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoFold = (props: IcoProps) => <MDSIcon.Fold {...props} />; //Fold;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoGridView = (props: IcoProps) => <MDSIcon.GridView {...props} />; //GridView;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoHelpBorder = (props: IcoProps) => <MDSIcon.Help variant="border" {...props} />; //HelpBorder;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoHome = (props: IcoProps) => <MDSIcon.Home variant="fill" {...props} />; //Home;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoImage = (props: IcoProps) => <MDSIcon.Image variant="fill" {...props} />; //Image;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoImages = (props: IcoProps) => <MDSIcon.Images variant="fill" {...props} />; //Images;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoInfoBorder = (props: IcoProps) => <MDSIcon.Info variant="border" {...props} />; //InfoBorder;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoInprogress = (props: IcoProps) => <MDSIcon.InProgress {...props} />; //Inprogress;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoLanguage = (props: IcoProps) => <MDSIcon.Language {...props} />; //Language;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoMinusFill = (props: IcoProps) => <MDSIcon.Minus variant="fill" {...props} />; //MinusFill;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoMoreVertical = (props: IcoProps) => <MDSIcon.More variant="vertical" {...props} />; //MoreVertical;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoOpenNew = (props: IcoProps) => <MDSIcon.OpenNew {...props} />; //OpenNew;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoPdf = (props: IcoProps) => <MDSIcon.Pdf variant="fill" {...props} />; //Pdf;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoPptFill = (props: IcoProps) => <MDSIcon.Ppt variant="fill" {...props} />; //PptFill;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoPriorityBorder = (props: IcoProps) => <MDSIcon.Priority variant="border" {...props} />; //PriorityBorder;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoProtectionWarning = (props?: IcoProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="24" height="24" fill="white" fillOpacity="0.01" />
    <path
      d="M11.3 2.26L5.3 4.51C4.52 4.81 4 5.55 4 6.39V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V6.39C20 5.56 19.48 4.81 18.7 4.52L12.7 2.27C12.25 2.09 11.75 2.09 11.3 2.26ZM12 16C11.45 16 11 15.55 11 15C11 14.45 11.45 14 12 14C12.55 14 13 14.45 13 15C13 15.55 12.55 16 12 16ZM12 12C11.45 12 11 11.55 11 11V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V11C13 11.55 12.55 12 12 12Z"
      fill="currentColor"
    />
  </svg>
);

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoPushLeft = (props: IcoProps) => <MDSIcon.PushLeft {...props} />; //PushLeft;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoPushRight = (props: IcoProps) => <MDSIcon.PushRight {...props} />; //PushRight;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoRefresh = (props: IcoProps) => <MDSIcon.Refresh {...props} />; //Refresh;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoRadioSelected = (props?: IcoProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="24" height="24" fill="white" fillOpacity="0.01" />
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z"
      fill="#1648D2"
    />
    <path
      d="M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z"
      fill="white"
    />
  </svg>
);

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoRadioSelectedDisabled = (props?: IcoProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="24" height="24" fill="white" fillOpacity="0.01" />
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z"
      fill="#A3B9F5"
    />
    <path
      d="M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z"
      fill="white"
    />
  </svg>
);

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoRadioUnselected = (props?: IcoProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="24" height="24" fill="white" fillOpacity="0.01" />
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
      fill="#C4CDD5"
    />
  </svg>
);

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoRadioUnselectedDisabled = (props?: IcoProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="24" height="24" fill="white" fillOpacity="0.01" />
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z"
      fill="#F9FAFB"
    />
    <path
      d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
      fill="#EAEDF0"
    />
  </svg>
);

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoSearchEarth = (props: IcoProps) => <MDSIcon.SearchEarth {...props} />; //SearchEarth;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoSearch = (props: IcoProps) => <MDSIcon.Search {...props} />; //Search;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoSort = (props: IcoProps) => <MDSIcon.Sort {...props} />; //Sort;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoTask = (props: IcoProps) => <MDSIcon.Task {...props} />; //Task;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoTipsFill = (props: IcoProps) => <MDSIcon.Tips variant="fill" {...props} />; //TipsFill;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoTrashOutline = (props: IcoProps) => <MDSIcon.Trash variant="outline" {...props} />; //TrashOutline;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoUnfold = (props: IcoProps) => <MDSIcon.Unfold {...props} />; //Unfold;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoUpload = (props: IcoProps) => <MDSIcon.Upload {...props} />; //Upload;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoDividerCircle = (props?: IcoProps) => (
  <svg width="2" height="2" viewBox="0 0 2 2" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0 1C0 0.447715 0.447715 0 1 0C1.55228 0 2 0.447715 2 1C2 1.55228 1.55228 2 1 2C0.447715 2 0 1.55228 0 1Z"
      fill="#AAB5C0"
    />
  </svg>
);

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoReset = (props: IcoProps) => <MDSIcon.Reset {...props} />; //Reset;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoToggleOn = (props?: IcoProps) => (
  <svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="32" height="20" rx="10" fill="#1648D2" />
    <rect width="20" height="20" transform="translate(12)" fill="white" fillOpacity="0.01" />
    <path
      d="M22 1.66669C17.4 1.66669 13.6667 5.40002 13.6667 10C13.6667 14.6 17.4 18.3334 22 18.3334C26.6 18.3334 30.3333 14.6 30.3333 10C30.3333 5.40002 26.6 1.66669 22 1.66669ZM19.7417 13.575L16.75 10.5834C16.425 10.2584 16.425 9.73335 16.75 9.40835C17.075 9.08335 17.6 9.08335 17.925 9.40835L20.3333 11.8084L26.0667 6.07502C26.3917 5.75002 26.9167 5.75002 27.2417 6.07502C27.5667 6.40002 27.5667 6.92502 27.2417 7.25002L20.9167 13.575C20.6 13.9 20.0667 13.9 19.7417 13.575Z"
      fill="white"
    />
  </svg>
);

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoToggleOff = (props?: IcoProps) => (
  <svg width="32" height="20" viewBox="0 0 32 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="32" height="20" rx="10" fill="#C4CDD5" />
    <circle cx="10" cy="10" r="8" fill="white" />
  </svg>
);

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IllustHandBoard = (props?: IcoProps) => (
  <svg width="116" height="72" viewBox="0 0 116 72" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M68.6013 17.3221C68.6013 17.3221 67.6148 18.3086 69.4476 25.7891C71.2803 33.2696 75.446 38.9829 75.446 38.9829C77.0783 37.4348 78.281 35.4898 78.9366 33.3378C79.5922 31.1859 79.6782 28.9006 79.1862 26.7055C77.6247 18.9351 68.6013 17.3221 68.6013 17.3221Z"
      fill="#142A66"
    />
    <path
      d="M69.6508 39.3358C69.6508 39.3358 68.2482 39.759 64.9241 43.2164C61.5999 46.6738 56.7423 48.4363 50.9542 51.0475C45.1662 53.6587 42.3446 41.5216 43.8267 35.3852C45.2293 29.2465 51.5877 25.013 51.5877 25.013L63.9259 26.7055C63.9259 26.7055 68.0191 21.8361 69.6415 25.0107C71.203 28.1876 71.0628 35.3127 69.6508 39.3358Z"
      fill="#FCD2CB"
    />
    <path
      d="M59.0683 61.8429L17.016 71.5091C16.5799 71.6113 16.1279 71.6265 15.686 71.5537C15.244 71.4809 14.8207 71.3215 14.4404 71.0848C14.0602 70.8481 13.7304 70.5386 13.4699 70.1742C13.2095 69.8098 13.0236 69.3975 12.9228 68.961L1.00071 17.3221C0.898019 16.8866 0.882256 16.4351 0.954328 15.9935C1.0264 15.5519 1.18489 15.1289 1.42072 14.7487C1.65655 14.3684 1.96508 14.0385 2.32865 13.7777C2.69221 13.5169 3.10366 13.3304 3.53942 13.2288L45.5916 3.5626C46.0271 3.46029 46.4785 3.44488 46.92 3.51727C47.3614 3.58966 47.7842 3.74841 48.1642 3.98445C48.5442 4.22048 48.874 4.52916 49.1345 4.89281C49.395 5.25645 49.5813 5.66792 49.6825 6.10364L61.5368 57.7403C61.6548 58.172 61.6841 58.6231 61.6227 59.0665C61.5614 59.5098 61.4108 59.9361 61.1801 60.3196C60.9493 60.7031 60.6432 61.0358 60.2803 61.2976C59.9173 61.5594 59.505 61.7449 59.0683 61.8429Z"
      fill="#F1F4F6"
    />
    <path
      d="M33.3842 57.3967L22.0957 60.0078C21.8824 60.0575 21.6614 60.0639 21.4456 60.0267C21.2299 59.9894 21.0238 59.9092 20.8396 59.7908C20.6554 59.6725 20.4968 59.5183 20.3733 59.3376C20.2497 59.1568 20.1637 58.9531 20.1203 58.7385L17.5092 47.4546C17.4595 47.2412 17.4532 47.02 17.4906 46.8041C17.528 46.5882 17.6084 46.3821 17.727 46.1978C17.8456 46.0136 18 45.8551 18.181 45.7317C18.3621 45.6082 18.566 45.5224 18.7808 45.4793L30.0694 42.8704C30.2827 42.8207 30.5037 42.8143 30.7194 42.8516C30.9352 42.8889 31.1413 42.9691 31.3255 43.0875C31.5097 43.2058 31.6682 43.36 31.7918 43.5407C31.9153 43.7215 32.0014 43.9252 32.0447 44.1398L34.6559 55.4284C34.7163 55.8546 34.621 56.2883 34.3874 56.6498C34.1538 57.0114 33.7976 57.2766 33.3842 57.3967V57.3967Z"
      fill="white"
    />
    <path
      d="M41.3579 18.3787L13.9817 24.66C13.7683 24.7097 13.5471 24.716 13.3312 24.6785C13.1153 24.6411 12.9091 24.5607 12.7249 24.4421C12.5407 24.3235 12.3821 24.1691 12.2587 23.9881C12.1353 23.8071 12.0495 23.6031 12.0063 23.3883V23.3883C11.9566 23.1751 11.9502 22.954 11.9875 22.7383C12.0248 22.5225 12.105 22.3165 12.2234 22.1323C12.3417 21.9481 12.4958 21.7895 12.6766 21.6659C12.8574 21.5424 13.0611 21.4564 13.2757 21.413L40.652 15.134C40.8652 15.0843 41.0862 15.0779 41.302 15.1152C41.5177 15.1525 41.7238 15.2327 41.908 15.351C42.0922 15.4694 42.2508 15.6235 42.3743 15.8043C42.4979 15.985 42.5839 16.1888 42.6273 16.4034V16.4034C42.6907 16.8305 42.5969 17.2661 42.3635 17.6294C42.1301 17.9926 41.7728 18.2589 41.3579 18.3787V18.3787Z"
      fill="#768695"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.1511 24.7279C45.2298 25.0695 45.0167 25.4102 44.6751 25.4889L14.0542 32.544C13.7126 32.6226 13.3719 32.4095 13.2932 32.068C13.2145 31.7264 13.4276 31.3857 13.7692 31.307L44.3901 24.2519C44.7317 24.1732 45.0724 24.3863 45.1511 24.7279Z"
      fill="#AAB5C0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.3503 29.8777C46.429 30.2193 46.216 30.56 45.8744 30.6387L15.2534 37.6962C14.9119 37.7749 14.5712 37.5618 14.4924 37.2202C14.4137 36.8787 14.6268 36.538 14.9683 36.4592L45.5893 29.4018C45.9309 29.3231 46.2716 29.5362 46.3503 29.8777Z"
      fill="#AAB5C0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.3251 38.5558C48.4047 38.8972 48.1925 39.2385 47.8511 39.3181L36.3522 41.9994C36.0108 42.079 35.6696 41.8668 35.59 41.5254C35.5104 41.184 35.7226 40.8428 36.0639 40.7632L47.5629 38.0819C47.9043 38.0023 48.2455 38.2145 48.3251 38.5558Z"
      fill="#AAB5C0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.6681 44.2034C49.7452 44.5453 49.5306 44.885 49.1887 44.9622L37.6173 47.5734C37.2754 47.6505 36.9356 47.4359 36.8585 47.094C36.7813 46.7521 36.996 46.4123 37.3379 46.3352L48.9093 43.724C49.2512 43.6468 49.5909 43.8615 49.6681 44.2034Z"
      fill="#AAB5C0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.35 50.8338C46.4293 51.1752 46.2168 51.5163 45.8754 51.5956L38.8905 53.2179C38.549 53.2972 38.208 53.0847 38.1287 52.7433C38.0494 52.4018 38.2619 52.0608 38.6033 51.9815L45.5882 50.3591C45.9296 50.2798 46.2707 50.4923 46.35 50.8338Z"
      fill="#AAB5C0"
    />
    <path
      d="M32.4679 8.21923L17.5093 11.6883C17.2658 11.7392 17.0135 11.7284 16.7753 11.6569C16.537 11.5854 16.3205 11.4554 16.1453 11.2789C15.9701 11.1023 15.8419 10.8847 15.7723 10.6459C15.7026 10.4072 15.6938 10.1548 15.7467 9.9117L15.8869 9.2104C15.9526 8.93631 16.0928 8.68574 16.2921 8.48645C16.4914 8.28716 16.7419 8.14694 17.016 8.08131L31.3389 4.76182C31.6073 4.69594 31.8888 4.7073 32.1511 4.79457C32.4133 4.88185 32.6455 5.04149 32.8209 5.25507L33.244 5.82079C33.95 6.73715 33.5362 8.00884 32.4679 8.21923Z"
      fill="#5FC1D2"
    />
    <path
      d="M64.924 22.4018C64.924 22.4018 63.1591 23.3182 59.7812 22.4018C56.4033 21.4854 55.8306 20.6369 52.3007 19.7205C48.7708 18.8041 43.9038 19.7906 43.0576 21.2727C42.2114 22.7548 44.4602 23.6712 47.4992 24.0241C50.5381 24.3771 51.9407 30.1629 56.8124 32.3486C64.924 35.9486 72.1193 24.9405 64.924 22.4018Z"
      fill="#FCD2CB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.3653 20.7216C43.6697 20.8954 43.7756 21.283 43.6018 21.5874C43.4732 21.8126 43.4982 21.9298 43.5358 22.0108C43.5931 22.1342 43.7546 22.3153 44.1195 22.5153C44.8457 22.9134 46.0681 23.2198 47.5654 23.3937C48.5272 23.5054 49.3096 24.0435 49.99 24.7145C50.6122 25.3281 51.2083 26.1145 51.8123 26.9114C51.8638 26.9793 51.9153 27.0473 51.9669 27.1152C53.3118 28.886 54.7943 30.7507 57.0652 31.7695L57.0726 31.7729C58.4476 32.411 59.9906 32.593 61.4764 32.2922C61.8199 32.2227 62.1548 32.4448 62.2243 32.7884C62.2939 33.1319 62.0718 33.4668 61.7282 33.5364C59.9785 33.8906 58.1615 33.6767 56.5419 32.926C53.9432 31.7588 52.2896 29.6389 50.9561 27.883C50.9091 27.8211 50.8626 27.7598 50.8166 27.6991C50.1939 26.8782 49.6524 26.1644 49.0987 25.6183C48.5091 25.0369 47.9766 24.7194 47.4189 24.6546C45.8772 24.4755 44.4557 24.1472 43.5093 23.6284C43.0379 23.37 42.606 23.022 42.3846 22.5457C42.1437 22.027 42.2049 21.4739 42.4994 20.958C42.6732 20.6536 43.0609 20.5478 43.3653 20.7216Z"
      fill="#F2A091"
    />
    <path
      d="M70.2867 19.1548C70.2867 19.1548 66.5464 21.5556 64.9241 22.4018C64.9241 22.4018 68.0986 25.5062 69.3656 31.0792C70.6326 36.6522 69.6485 39.3358 69.6485 39.3358C69.6485 39.3358 73.8119 38.9103 75.8573 37.4306C75.8573 37.4306 77.8326 34.1836 76.2103 27.8345C74.5879 21.4854 70.2867 19.1548 70.2867 19.1548Z"
      fill="#F1F4F6"
    />
    <path
      d="M114.595 10.5475C113.948 8.38874 112.798 6.41447 111.239 4.78756C109.68 3.16064 107.756 1.92771 105.627 1.19044C103.498 0.453165 101.223 0.232683 98.9921 0.547174C96.7608 0.861666 94.6362 1.70212 92.7935 2.99922C88.1369 6.2439 83.2675 9.41845 79.387 11.5364L68.6011 17.3922C68.6011 17.3922 74.7398 23.4585 75.6585 30.1629C76.5772 36.8673 75.4457 39.046 75.4457 39.046C75.4457 39.046 92.3096 34.8826 107.196 27.6148C113.475 24.4403 116.649 17.2426 114.604 10.5499L114.595 10.5475Z"
      fill="#2D5FE9"
    />
    <path
      d="M74.0245 33.8961C74.024 33.7289 73.974 33.5655 73.8807 33.4266C73.7875 33.2878 73.6552 33.1797 73.5005 33.116C73.3458 33.0523 73.1757 33.0359 73.0117 33.0688C72.8477 33.1017 72.6972 33.1825 72.5791 33.3009C72.4609 33.4194 72.3806 33.5702 72.3481 33.7342C72.3157 33.8983 72.3326 34.0684 72.3967 34.2229C72.4608 34.3773 72.5693 34.5094 72.7084 34.6023C72.8475 34.6951 73.011 34.7447 73.1783 34.7447C73.2907 34.749 73.4029 34.73 73.5077 34.6888C73.6124 34.6476 73.7075 34.5853 73.787 34.5056C73.8665 34.4259 73.9286 34.3306 73.9695 34.2257C74.0104 34.1208 74.0291 34.0086 74.0245 33.8961Z"
      fill="#142A66"
    />
  </svg>
);

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoLinkUrl = (props?: IcoProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="24" height="24" fill="white" fillOpacity="0.01" />
    <path
      d="M17 7H14C13.45 7 13 7.45 13 8C13 8.55 13.45 9 14 9H17C18.65 9 20 10.35 20 12C20 13.65 18.65 15 17 15H14C13.45 15 13 15.45 13 16C13 16.55 13.45 17 14 17H17C19.76 17 22 14.76 22 12C22 9.24 19.76 7 17 7ZM8 12C8 12.55 8.45 13 9 13H15C15.55 13 16 12.55 16 12C16 11.45 15.55 11 15 11H9C8.45 11 8 11.45 8 12ZM10 15H7C5.35 15 4 13.65 4 12C4 10.35 5.35 9 7 9H10C10.55 9 11 8.55 11 8C11 7.45 10.55 7 10 7H7C4.24 7 2 9.24 2 12C2 14.76 4.24 17 7 17H10C10.55 17 11 16.55 11 16C11 15.45 10.55 15 10 15Z"
      fill="currentColor"
    />
  </svg>
);

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoPDFFill = (props: IcoProps) => <MDSIcon.Pdf variant="fill" {...props} />; //PDFFill;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoTailArrowDown = (props: IcoProps) => <MDSIcon.TailArrowDown {...props} />; //TailArrowDown;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoMenu = (props: IcoProps) => <MDSIcon.Menu {...props} />;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoEqualizer = (props: IcoProps) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3433_57412)">
      <rect width="20" height="20" fill="white" fillOpacity="0.01" />
      <path
        d="M6.66667 15C7.125 15 7.5 14.625 7.5 14.1667V5.83335C7.5 5.37502 7.125 5.00002 6.66667 5.00002C6.20833 5.00002 5.83333 5.37502 5.83333 5.83335V14.1667C5.83333 14.625 6.20833 15 6.66667 15ZM10 18.3334C10.4583 18.3334 10.8333 17.9584 10.8333 17.5V2.50002C10.8333 2.04169 10.4583 1.66669 10 1.66669C9.54167 1.66669 9.16667 2.04169 9.16667 2.50002V17.5C9.16667 17.9584 9.54167 18.3334 10 18.3334ZM3.33333 11.6667C3.79167 11.6667 4.16667 11.2917 4.16667 10.8334V9.16669C4.16667 8.70835 3.79167 8.33335 3.33333 8.33335C2.875 8.33335 2.5 8.70835 2.5 9.16669V10.8334C2.5 11.2917 2.875 11.6667 3.33333 11.6667ZM13.3333 15C13.7917 15 14.1667 14.625 14.1667 14.1667V5.83335C14.1667 5.37502 13.7917 5.00002 13.3333 5.00002C12.875 5.00002 12.5 5.37502 12.5 5.83335V14.1667C12.5 14.625 12.875 15 13.3333 15ZM15.8333 9.16669V10.8334C15.8333 11.2917 16.2083 11.6667 16.6667 11.6667C17.125 11.6667 17.5 11.2917 17.5 10.8334V9.16669C17.5 8.70835 17.125 8.33335 16.6667 8.33335C16.2083 8.33335 15.8333 8.70835 15.8333 9.16669Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3433_57412">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

/**
 * @deprecated
 * mds-v2 로 변경
 */
// export const IcoCheckbox = Checkbox;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoSellerPersonFill = (props: IcoProps) => <MDSIcon.SellerPerson variant="fill" {...props} />; //SellerPersonFill;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoSellerPersonOutline = (props: IcoProps) => <MDSIcon.SellerPerson variant="outline" {...props} />; //SellerPersonOutline;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoServer = (props?: IcoProps) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="24" height="24" transform="translate(0 0.345703)" fill="white" fillOpacity="0.01" />
    <path
      d="M7.5 6.3457C7.08333 6.3457 6.72917 6.49154 6.4375 6.7832C6.14583 7.07487 6 7.42904 6 7.8457C6 8.26237 6.14583 8.61654 6.4375 8.9082C6.72917 9.19987 7.08333 9.3457 7.5 9.3457C7.91667 9.3457 8.27083 9.19987 8.5625 8.9082C8.85417 8.61654 9 8.26237 9 7.8457C9 7.42904 8.85417 7.07487 8.5625 6.7832C8.27083 6.49154 7.91667 6.3457 7.5 6.3457ZM7.5 16.3457C7.08333 16.3457 6.72917 16.4915 6.4375 16.7832C6.14583 17.0749 6 17.429 6 17.8457C6 18.2624 6.14583 18.6165 6.4375 18.9082C6.72917 19.1999 7.08333 19.3457 7.5 19.3457C7.91667 19.3457 8.27083 19.1999 8.5625 18.9082C8.85417 18.6165 9 18.2624 9 17.8457C9 17.429 8.85417 17.0749 8.5625 16.7832C8.27083 16.4915 7.91667 16.3457 7.5 16.3457ZM4 3.3457H20C20.2833 3.3457 20.5208 3.44154 20.7125 3.6332C20.9042 3.82487 21 4.06237 21 4.3457V11.3457C21 11.629 20.9042 11.8665 20.7125 12.0582C20.5208 12.2499 20.2833 12.3457 20 12.3457H4C3.71667 12.3457 3.47917 12.2499 3.2875 12.0582C3.09583 11.8665 3 11.629 3 11.3457V4.3457C3 4.06237 3.09583 3.82487 3.2875 3.6332C3.47917 3.44154 3.71667 3.3457 4 3.3457ZM5 5.3457V10.3457H19V5.3457H5ZM4 13.3457H20C20.2833 13.3457 20.5208 13.4415 20.7125 13.6332C20.9042 13.8249 21 14.0624 21 14.3457V21.3457C21 21.629 20.9042 21.8665 20.7125 22.0582C20.5208 22.2499 20.2833 22.3457 20 22.3457H4C3.71667 22.3457 3.47917 22.2499 3.2875 22.0582C3.09583 21.8665 3 21.629 3 21.3457V14.3457C3 14.0624 3.09583 13.8249 3.2875 13.6332C3.47917 13.4415 3.71667 13.3457 4 13.3457ZM5 15.3457V20.3457H19V15.3457H5Z"
      fill="#212B36"
    />
  </svg>
);

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoSiteMap = (props?: IcoProps) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="24" height="24" transform="translate(0 0.345703)" fill="white" fillOpacity="0.01" />
    <path
      d="M15 19.3457V18.3457H13C12.45 18.3457 11.9792 18.1499 11.5875 17.7582C11.1958 17.3665 11 16.8957 11 16.3457V8.3457H9V9.3457C9 9.8957 8.80417 10.3665 8.4125 10.7582C8.02083 11.1499 7.55 11.3457 7 11.3457H4C3.45 11.3457 2.97917 11.1499 2.5875 10.7582C2.19583 10.3665 2 9.8957 2 9.3457V5.3457C2 4.7957 2.19583 4.32487 2.5875 3.9332C2.97917 3.54154 3.45 3.3457 4 3.3457H7C7.55 3.3457 8.02083 3.54154 8.4125 3.9332C8.80417 4.32487 9 4.7957 9 5.3457V6.3457H15V5.3457C15 4.7957 15.1958 4.32487 15.5875 3.9332C15.9792 3.54154 16.45 3.3457 17 3.3457H20C20.55 3.3457 21.0208 3.54154 21.4125 3.9332C21.8042 4.32487 22 4.7957 22 5.3457V9.3457C22 9.8957 21.8042 10.3665 21.4125 10.7582C21.0208 11.1499 20.55 11.3457 20 11.3457H17C16.45 11.3457 15.9792 11.1499 15.5875 10.7582C15.1958 10.3665 15 9.8957 15 9.3457V8.3457H13V16.3457H15V15.3457C15 14.7957 15.1958 14.3249 15.5875 13.9332C15.9792 13.5415 16.45 13.3457 17 13.3457H20C20.55 13.3457 21.0208 13.5415 21.4125 13.9332C21.8042 14.3249 22 14.7957 22 15.3457V19.3457C22 19.8957 21.8042 20.3665 21.4125 20.7582C21.0208 21.1499 20.55 21.3457 20 21.3457H17C16.45 21.3457 15.9792 21.1499 15.5875 20.7582C15.1958 20.3665 15 19.8957 15 19.3457ZM17 9.3457H20V5.3457H17V9.3457ZM17 19.3457H20V15.3457H17V19.3457ZM4 9.3457H7V5.3457H4V9.3457Z"
      fill="#212B36"
    />
  </svg>
); //SiteMap;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoSellers = (props?: IcoProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="24" height="24" fill="white" fillOpacity="0.01" />
    <path
      d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V18C1 18.55 1.45 19 2 19H14C14.55 19 15 18.55 15 18V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C15.05 13.06 15.06 13.08 15.07 13.09C16.21 13.92 17 15.03 17 16.5V18C17 18.35 16.93 18.69 16.82 19H22C22.55 19 23 18.55 23 18V16.5C23 14.17 18.33 13 16 13Z"
      fill="currentColor"
    />
  </svg>
);

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoMenuClose = (props: IcoProps) => <MDSIcon.MenuClose {...props} />;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoCheckboxFilled = (props?: IcoProps) => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="16" height="16" transform="translate(0 0.438965)" fill="white" fillOpacity="0.01" />
    <path
      d="M12.6667 2.43896H3.33333C2.6 2.43896 2 3.03896 2 3.7723V13.1056C2 13.839 2.6 14.439 3.33333 14.439H12.6667C13.4 14.439 14 13.839 14 13.1056V3.7723C14 3.03896 13.4 2.43896 12.6667 2.43896ZM7.14 11.299C6.88 11.559 6.46 11.559 6.2 11.299L3.80667 8.90563C3.54667 8.64563 3.54667 8.22563 3.80667 7.96563C4.06667 7.70563 4.48667 7.70563 4.74667 7.96563L6.66667 9.88563L11.2533 5.29896C11.5133 5.03896 11.9333 5.03896 12.1933 5.29896C12.4533 5.55896 12.4533 5.97896 12.1933 6.23896L7.14 11.299Z"
      fill="#1648D2"
    />
  </svg>
);

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoRemoveOutline = (props: IcoProps) => <MDSIcon.CloseDelete variant="outline" {...props} />; //RemoveOutline;

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoNoFavicon = (props?: IcoProps) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_6488_421)">
      <rect width="32" height="32.0001" rx="4" fill="#F9FAFB" />
      <rect width="24" height="24" transform="translate(4 4)" fill="white" fillOpacity="0.01" />
      <path
        d="M24.4752 27.3L22.1752 25H9.0002C8.4502 25 7.97936 24.8042 7.5877 24.4125C7.19603 24.0208 7.0002 23.55 7.0002 23V9.82501L4.7002 7.50001L6.1002 6.10001L25.9002 25.9L24.4752 27.3ZM9.0002 23H20.1752L18.1752 21H10.0002L13.0002 17L15.0002 19.725L15.8502 18.675L9.0002 11.825V23ZM25.0002 22.175L23.0002 20.175V9.00001H11.8252L9.8252 7.00001H23.0002C23.5502 7.00001 24.021 7.19584 24.4127 7.58751C24.8044 7.97917 25.0002 8.45001 25.0002 9.00001V22.175Z"
        fill="#C4CDD5"
      />
    </g>
    <defs>
      <clipPath id="clip0_6488_421">
        <rect width="32" height="32.0001" rx="4" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoTable = (props?: IcoProps) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 1.33333C0 0.596954 0.596954 0 1.33333 0H10.6667C11.403 0 12 0.596954 12 1.33333V10.6667C12 11.403 11.403 12 10.6667 12H1.33333C0.596954 12 0 11.403 0 10.6667V1.33333ZM4.66667 5.33333H10.6667V7.33333H4.66667V5.33333ZM4.66667 4H10.6667V1.33333H4.66667V4ZM3.33333 1.33333V4H1.33333V1.33333H3.33333ZM3.33333 5.33333V7.33333H1.33333V5.33333H3.33333ZM3.33333 8.66667H1.33333V10.6667H3.33333V8.66667ZM4.66667 10.6667H10.6667V8.66667H4.66667V10.6667Z"
      fill="currentColor"
    />
  </svg>
);

/**
 * @deprecated
 * mds-v2 로 변경
 */
export const IcoCheckbox = (props?: IcoProps) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="16" height="16" fill="white" fillOpacity="0.01" />
    <path
      d="M12.6667 12.6667L3.33333 12.6667V3.33333H12.6667V12.6667ZM12.6667 2H3.33333C2.6 2 2 2.6 2 3.33333V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V3.33333C14 2.6 13.4 2 12.6667 2Z"
      fill="#212B36"
    />
  </svg>
);
